import { GeneralStoreEntity } from './general-store.entity';
import { castToType, CastTypes } from '../utils/type-casting,util';

export abstract class CacheablesEntity extends GeneralStoreEntity {

  protected get identifier() {
    return this.identifierString;
  }

  protected set identifier(id) {
    this.identifierString = id;
  }

  protected constructor(item: any) {
    super(item);
  }
  protected identifierString: string = null;

  public static builder(payload) {
    const instance = this as any;
    return new instance(payload);

  }

  protected abstract generateIdentifier(): Promise<string>;

  protected abstract generateIdentifierSync(): string;

  public getIdentifier() {
    return this.identifier;
  }

  public setIdentifier() {
    return this.generateIdentifier()
      .then(id => this.identifier = id)
      .then(() => {
        return this;
      });
  }

  public setIdentifierSync() {
    this.identifier = this.generateIdentifierSync();
    return this;
  }

  valueOf() {
    return { [this.identifier]: this.value};
  }

  remove<T = any>(state: T, id: string = this.identifier) {
    const castedState = this.castToObject(state);
    delete castedState[id];
    return this.castToOriginalType(castedState);
  }

  upsert<T = any>(state: T, key: string = null, upsertValues = this.value, castValuesTo: CastTypes = null) {
    const castedState = this.castToObject(state);
    let values = castedState[this.identifier];
    if (!values) {
      values = this.isArray ? [] : { };
    }
    else if (castValuesTo) {
      values = Array.isArray(values)
        ? castToType(CastTypes.ARRAY, values)
        : castToType(CastTypes.OBJECT, values);
    }

    upsertValues = key ? { [key]: upsertValues} : upsertValues;
    castedState[this.identifier] = this.isArray && !key
      ? [...(values as any[] || []), ...upsertValues]
      : Object.assign({ }, values, upsertValues);

    if (castValuesTo) {
      castedState[this.identifier] = castToType(castValuesTo, castedState[this.identifier], true);
    }

    return this.castToOriginalType(castedState);
  }

  public init(state: any, key: string = this.identifier, initValue: any = this.valueOf()) {
    return super.init(state, key, initValue);
  }

  getCachedRecordFromState(state: any, fallback: any = null) {
    const originalType = state.constructor.name;
    state = castToType('object', state);
    state = state && this.identifier in state
      ? state[this.identifier]
      : fallback;
    return castToType(originalType, state);

  }


}
